import { Message } from 'primeng/api'

/**
 * Lo que pasó al pedir «olvidé mi contraseña», tal como se le puede contar a quien lo pidió (B-006).
 *
 * `sent` no afirma que el correo exista: el backend responde igual exista o no, para no revelar qué
 * correos tienen cuenta. Los demás casos sí dependen solo de lo que la persona hizo, así que se dicen.
 */
export type ForgotPasswordOutcome = 'sent' | 'rate-limited' | 'invalid' | 'failed'

export function forgotPasswordOutcome(httpStatus: number | null | undefined): ForgotPasswordOutcome {
  if (httpStatus === 429) return 'rate-limited'
  if (httpStatus === 400) return 'invalid'
  return 'failed'
}

export const FORGOT_PASSWORD_MESSAGES: Record<ForgotPasswordOutcome, Message> = {
  sent: {
    severity: 'info',
    summary: 'Si el correo está registrado, te enviamos una contraseña temporal. Al iniciar sesión se te pedirá cambiarla.',
  },
  'rate-limited': { severity: 'warn', summary: 'Demasiados intentos. Espera un minuto y vuelve a intentarlo.' },
  invalid: { severity: 'warn', summary: 'Escribe un correo válido.' },
  failed: { severity: 'error', summary: 'No pudimos procesar la solicitud, intenta de nuevo.' },
}
